




































































































// https://stackoverflow.com/questions/51929431/add-search-and-sort-functionality-to-vuetifyjs-list-with-vuejs-2/51930328
import Vue from 'vue'
import { vxm } from '@/state/index'
import Pod from '@/components/layouts/Pod.vue'
import { Client } from '@/state/clientFlowtypes'
import { getHumanDateFromUnixTimestamp } from '@/lib/utils/getHumanDateFromUnixTimeStamp'
import { compareObjectsByKeyValue } from '@/lib/utils/sort/compareObjectsByKeyValue'

interface LocalClient extends Client {
  created: number;
  id: string;
  createdLocalizedDate: string;
}

export default Vue.extend({
  name: 'ClientsList',
  components: {
    Pod,
  },
  props: {
    noClientsText: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      loading: true,
      search: null,
      sortByDate: false,
      // sortOption: 'name',
      sortKey: 'name',
    }
  },

  computed: {
    // Use this as a hidden cache for all the clients we get
    // use clients() for the clients we display (e.g. filtered)
    cachedClients(): LocalClient[] {
      const clients = []
      // Firestore will return an object with the client id's as keys
      // We will convert it into an array of client objects with the key as 'id' property
      const clientsObj = this.$store.getters['clients/all']
      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(clientsObj as [Client])) {
        clients.push({
          id: key,
          ...value,
          created: value.dbCreatedAt.seconds,
          createdLocalizedDate: getHumanDateFromUnixTimestamp(
            value.dbCreatedAt.seconds,
            this.$vuetify.lang.current,
            { year: 'numeric', month: 'short', day: 'numeric' },
          ),
        })
      }
      const desc = !(this.sortKey === 'name') // only name should be sorted ascending
      return clients.sort(compareObjectsByKeyValue({ key: this.sortKey as keyof Client, desc }))
    },

    clients(): LocalClient[] {
      if (this.search) {
        if (typeof this.search === 'string') {
          const s = this.search as unknown as string
          if (s.trim() !== '' && s.length > 1) {
            const filtered = this.cachedClients.filter(
              (client) => client.name.toLowerCase().includes(s.toLowerCase())
              || client.email.toLowerCase().includes(s.toLowerCase()),
            )
            return filtered
          }
        }
      }
      return this.cachedClients
    },

    showNoClientsText(): boolean {
      return (this.cachedClients.length === 0 && !this.loading && this.noClientsText !== '')
    },
  },

  watch: {
    sortByDate: {
      handler(sortByDate) {
        if (sortByDate) this.sortKey = 'created'
        else { this.sortKey = 'name' }
      },
    },
  },

  beforeMount() {
    const userId = vxm.authUser.id
    try {
      // eslint-disable-next-line no-restricted-syntax
      this.loading = true
      this.$store.dispatch('clients/openDBChannel', { where: [['therapistId', '==', userId]] })
        .then(() => {
          this.loading = false
        })
    } catch (e) {
      this.loading = false

      /*
      console.log(typeof e)
      console.log(e)
      */
      // TODO:  check the error. It might just be that the dbchanell is already open
    }
  },

  methods: {
    getHumanDateFromUnixTimestamp(seconds: number) {
      return getHumanDateFromUnixTimestamp(seconds, this.$vuetify.lang.current)
    },
    openClientPage(clientId: string) {
      this.$router.push({ name: 'journal', params: { clientId } })
    },
  },
})

